<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import PauseTypeForm from './PauseTypeForm.vue';

const { t } = useI18n();
const store = useStore();
const route = useRoute();
const router = useRouter();

const uiFlags = useMapGetter('agentPauseTypes/getUIFlags');
const records = useMapGetter('agentPauseTypes/allPauseTypes');
const currentAccountId = useMapGetter('getCurrentAccountId');

const pauseTypeId = computed(() => Number(route.params.pauseTypeId));
const pauseType = computed(
  () => records.value.find(r => r.id === pauseTypeId.value) || {}
);

onMounted(async () => {
  if (!records.value.length) {
    await store.dispatch('agentPauseTypes/fetch');
  }
});

const goToList = () => {
  router.push({
    name: 'agent_pause_types_list',
    params: { accountId: currentAccountId.value },
  });
};

const onSubmit = async payload => {
  try {
    await store.dispatch('agentPauseTypes/update', {
      id: pauseTypeId.value,
      ...payload,
    });
    useAlert(t('AGENT_PAUSE_TYPES.API.UPDATE_SUCCESS'));
    goToList();
  } catch (error) {
    useAlert(error?.message || t('AGENT_PAUSE_TYPES.API.ERROR'));
  }
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="t('AGENT_PAUSE_TYPES.EDIT_PAUSE_TYPE')"
        :description="t('AGENT_PAUSE_TYPES.DESCRIPTION')"
      />
    </template>
    <template #body>
      <div class="max-w-3xl">
        <PauseTypeForm
          :pause-type="pauseType"
          :submit-label="t('AGENT_PAUSE_TYPES.FORM.SUBMIT')"
          :is-submitting="uiFlags.isUpdating"
          @submit="onSubmit"
          @cancel="goToList"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
